import { isNil } from 'lodash'
import { PLAYER_TYPE } from 'enums'
import * as ActionTypes from './ActionTypes'
import { resetPlaybackClip } from './playback'
import { MARK_TYPE } from '~/config/constants/preview'
import { STORAGE_CONST } from '~/constant'
import { getDefaultTransitionDurationDataObj } from '~/helpers/getDefaultTransitionDurationDataObj'

export const setPreviewParams = (scale, boundingRect) => ({
  type: ActionTypes.SET_PREVIEW_PARAMS,
  payload: { scale, boundingRect },
})

export const toggleSplitPreview = () => ({
  type: ActionTypes.SPLIT_PREVIEW,
  payload: {},
})

export const setActivePreview = activePreview => ({
  type: ActionTypes.SET_ACTIVE_PREVIEW,
  payload: { activePreview },
})

export const setFullScreen = fullScreen => ({
  type: ActionTypes.SET_FULLSCREEN,
  payload: { fullScreen },
})

export const setResizableParams = ({ width, height }) => ({
  type: ActionTypes.SET_RESIZABLE_PARAMS,
  payload: { width, height },
})

export const setDuration = duration => ({
  type: ActionTypes.ON_CHANGE_DURATION,
  payload: { duration },
})

export const setPreviewMarker = ({
  preview,
  point,
  markType,
  showIOPoints = true,
  updateAsset = true,
}) => ({
  type: ActionTypes.SET_PREVIEW_MARKER,
  payload: {
    preview,
    point,
    markType,
    updateAsset,
    showIOPoints,
  },
})

export const resetMarkers = ({ preview, markType = null }) => (dispatch, getState) => {
  const state = getState()
  const ioPoints = state.preview.clipCreator
  if (isNil(ioPoints[preview].markIn) && isNil(ioPoints[preview].markOut)) {
    return
  }
  const prevShowInOutPoints = state.preview.showInOutPoints
  const historyProperties = {
    prevShowInOutPoints,
    nextShowInOutPoints: { ...prevShowInOutPoints, [preview]: false },
    nextIOPoints: markType
      ? {
        ...ioPoints,
        [preview]: { ...ioPoints[preview], [markType]: null },
      }
      : {
        ...ioPoints,
        [preview]: { markIn: null, markOut: null },
      },
    prevIOPoints: ioPoints,
    assetId: null,
  }
  dispatch({
    type: ActionTypes.RESET_MARK,
    payload: { preview, markType, historyProperties },
  })
}

export const resetNHideMarkers = (preview = null) => ({
  type: ActionTypes.RESET_N_HIDE_CLIP_MARKERS,
  payload: { preview },
})

export const setPreviewMarkers = (
  data, options
) => {
  const {
    showIOPoints,
    preview,
    updateAsset,
    initProps,
  } = { showIOPoints: true, preview: PLAYER_TYPE.MEDIA, updateAsset: true, ...(options ?? {}) }
  return {
    type: ActionTypes.SET_PREVIEW_MARKERS,
    payload: {
      data,
      showIOPoints,
      preview,
      updateAsset,
      initProps,
    },
  }
}

export const setIOPointsData = (clipCreator, showInOutPoints) => ({
  type: ActionTypes.SET_IO_POINTS_DATA,
  payload: {
    clipCreator,
    showInOutPoints,
  },
})

export const setProjectIOPoints = data => ({
  type: ActionTypes.SET_PROJECT_IO_POINTS,
  payload: { data },
})

export const updatePreviewMarkers = (assetId, initProps) => ({
  type: ActionTypes.UPDATE_PREVIEW_MARKERS,
  payload: { assetId, initProps },
})

export const setInOutPointsTimelineAsset = assetId => ({
  type: ActionTypes.SET_IN_OUT_POINTS_TIMELINE_ASSET,
  payload: {
    assetId,
  },
})

export const setShowInOutPoints = (show, preview = PLAYER_TYPE.MEDIA) => ({
  type: ActionTypes.SET_SHOW_IN_OUT_POINTS,
  payload: {
    show,
    preview,
  },
})

export const setInOutPointsMoving = isMoving => ({
  type: ActionTypes.SET_IN_OUT_POINTS_MOVING,
  payload: { isMoving },
})

export const setSourcePlayerProgress = progress => ({
  type: ActionTypes.SET_SOURCE_PLAYER_PROGRESS,
  payload: { progress },
})

export const setPreviewLoading = isLoading => ({
  type: ActionTypes.SET_PREVIEW_LOADING,
  payload: { isLoading },
})

export const setPreviewMode = mode => ({
  type: ActionTypes.SET_PREVIEW_MODE,
  payload: { mode },
})

export const setCanvasPlayerBoxBounds = bounds => ({
  type: ActionTypes.SET_CANVAS_PLAYER_BOX_BOUNDS,
  payload: { bounds },
})

export const extractProjectIOPoints = () => async (dispatch, getState) => {
  const { ioPoints } = getState().projectData?.activeProject ?? {}
  // reset source media playback
  dispatch(resetPlaybackClip())

  // reset prev i/o points
  dispatch(resetNHideMarkers())
  dispatch(setInOutPointsTimelineAsset(null))

  // set current project(timeline) i/o points
  dispatch(setProjectIOPoints({
    [MARK_TYPE.IN]: ioPoints?.markIn ?? null,
    [MARK_TYPE.OUT]: ioPoints?.markOut ?? null,
  }))
}

export const extractDefaultProjectTransDuration = () => async (_, getState) => {
  const { defaultTransitionDuration } = getState().projectData?.activeProject ?? {}
  sessionStorage.setItem(
    STORAGE_CONST.DEFAULT_TRANSITION_DURATION,
    JSON.stringify(defaultTransitionDuration || getDefaultTransitionDurationDataObj())
  )
}

export const setIOPointsHistoryData = data => ({
  type: ActionTypes.SET_IO_POINTS_HISTORY_DATA,
  payload: { data },
})

export const clearIOPointsHistoryData = () => ({
  type: ActionTypes.CLEAR_IO_POINTS_HISTORY_DATA,
  payload: {},
})
